module.exports = __webpack_public_path__ + "assets/client-min.d8230703ce26154862347bdc15afa959.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/MVEVA/client-min.jpg
 ** module id = 388
 ** module chunks = 0
 **/